import { render, staticRenderFns } from "./kodetransaksisimpanan.vue?vue&type=template&id=32b1fa1a&scoped=true&"
import script from "./kodetransaksisimpanan.vue?vue&type=script&lang=js&"
export * from "./kodetransaksisimpanan.vue?vue&type=script&lang=js&"
import style0 from "./kodetransaksisimpanan.vue?vue&type=style&index=0&id=32b1fa1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b1fa1a",
  null
  
)

export default component.exports